import { JSONAttributeValue } from "../../../../../../modules/FeatureCard/components/Attributes/types";

export enum ProjectInfoBlockType {
  MDE,
  GALLERY,
}

export enum AlignmentOption {
  Left = "left",
  Center = "center",
  Right = "right",
}

export interface GallerySettings {
  height?: number;
  width?: number;
  alignment: AlignmentOption;
  items: JSONAttributeValue[];
}

export interface ProjectInfoBlock {
  id?: string;
  type: ProjectInfoBlockType;
  value: string | GallerySettings;
}
